import { safeRenderPropComponent } from '@/utils'
import { ElementType, JSX } from 'react'
import { Input } from '../../styled'
import { Addon, Container } from './styles'

interface InputWithAddonProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  addonAfter?: JSX.Element | (() => JSX.Element | null)
  addonBefore?: JSX.Element | (() => JSX.Element | null)
  inputComponent?: any
  rounded?: boolean
}

export const InputWithAddon = ({
  addonBefore,
  addonAfter,
  inputComponent: Component = Input,
  ...rest
}: InputWithAddonProps) => {
  const AddonBefore = safeRenderPropComponent(addonBefore) as ElementType
  const AddonAfter = safeRenderPropComponent(addonAfter) as ElementType

  return (
    <Container hasPrefix={Boolean(addonBefore)} hasSuffix={Boolean(addonAfter)}>
      {addonBefore && (
        <Addon before>
          <AddonBefore />
        </Addon>
      )}
      <Component {...rest} />
      {addonAfter && (
        <Addon before={false}>
          <AddonAfter />
        </Addon>
      )}
    </Container>
  )
}
